import React, { createContext, useContext, useState } from 'react';

type NavTitleCtx = {
  navTitle: string;
  setNavTitle: (title: string) => void;
};

const NavTitleContext = createContext<NavTitleCtx>({ navTitle: 'Dashboard', setNavTitle: () => {} });

export const NavTitleProvider = ({ children }: { children: React.ReactNode }) => {
  const [navTitle, setNavTitle] = useState('Dashboard');
  return (
    <NavTitleContext.Provider value={{ navTitle, setNavTitle }}>
      {children}
    </NavTitleContext.Provider>
  );
};

export const useNavTitle = () => useContext(NavTitleContext);
